export default __webpack_public_path__ + "static/media/feat-mining.f07d7b93.svg";